export const ACCOUNT_ID_PARAM_NAME = 'accountId';
export const PUSH_API_ID_PARAM = 'subscriptionId';
export const ACCOUNT_ID_PARAM_TEMPLATE = `/:${ACCOUNT_ID_PARAM_NAME}?`;
export const PUSH_API_ID_PARAM_TEMPLATE = `/:${PUSH_API_ID_PARAM}?`;
